export default __webpack_public_path__ + "static/media/idbadge-1.eb755ef1.svg";